import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import PropTypes from 'prop-types';
import './menu.css';

const content = require('../content.json');

class Menu extends React.Component {
    render() {
        return (
            <div className="menu">
                <div className="header">
                    <Link to={this.props.location.state}>
                        <img alt="" className="cross" src="./images/mob/cross.png" />
                    </Link>
                    <div className="logos">
                        {content.logos.map((element) => (
                            <img
                                alt={element}
                                className="logo"
                                key={element}
                                src={`./images/page/logos/${element}`}
                            />
                        ))}
                    </div>
                </div>
                <div className="container">
                    <div className="images">
                        <img alt="" className="anton" src="./images/mob/anton.svg" />
                        <img alt="" className="paint" src="./images/mob/paint.svg" />
                        <img alt="" className="sky-1" src="./images/mob/sky-1.svg" />
                        <img alt="" className="sky-2" src="./images/mob/sky-2.svg" />
                    </div>
                    <ul className="list">
                        <li className="item">
                            <Link className="menu__link" to="/index#time">
                                Время думать об искусстве
                            </Link>
                        </li>
                        <li className="item">
                            <Link className="menu__link" to="/index#gifts">
                                Подарочки
                            </Link>
                        </li>
                        <li className="item">
                            <Link className="menu__link" to="/index#cards">
                                Шедевры Русского музея
                            </Link>
                        </li>
                        <li className="item">
                            <Link className="menu__link" to="/index#photostory">
                                Фотоистория
                            </Link>
                        </li>
                        <li className="item">
                            <Link className="menu__link" to="/index#lamoda">
                                Сувенирочка
                            </Link>
                        </li>
                        <li className="item">
                            <Link className="menu__link" to="/index#fund">
                                Фонд «Выход в Перетбурге»
                            </Link>
                        </li>
                        <li className="item">
                            <Link className="menu__link" to="/index#live">
                                Прямой эфир
                            </Link>
                        </li>
                    </ul>
                </div>
            </div>
        );
    }
}

Menu.propTypes = {
    location: PropTypes.object.isRequired
};

export default Menu;
